import { PayerAdvanceSearchItem } from "../models/payer-advance-search.model";
import { InsuranceOcrResult } from "../models/insurance-ocr.model";

/** Keys used to read payer/plan name from insurance OCR metadata (same family as referral / eligibility). */
export const INSURANCE_METADATA_PAYER_NAME_KEYS: string[] = [
  "PayerName",
  "payerName",
  "InsuranceName",
  "InsurancePayer",
  "PlanName",
  "InstituteName",
];

/**
 * Normalize for exact comparison: lowercase, trim, collapse internal whitespace.
 */
export function normalizePayerNameForExactMatch(value: string): string {
  return value
    .toLowerCase()
    .replace(/\s+/g, " ")
    .trim();
}

/**
 * First non-empty payer/plan string from persisted metadata or in-memory OCR result.
 */
export function extractInsurancePayerNameForSearch(
  metadata: Record<string, unknown> | null | undefined,
  session: InsuranceOcrResult | null
): string {
  if (session) {
    for (const key of INSURANCE_METADATA_PAYER_NAME_KEYS) {
      const v = (session as Record<string, unknown>)[key];
      if (v != null && String(v).trim() !== "") {
        return String(v).trim();
      }
    }
  }
  if (!metadata || typeof metadata !== "object") {
    return "";
  }
  for (const key of INSURANCE_METADATA_PAYER_NAME_KEYS) {
    const v = metadata[key];
    if (v != null && String(v).trim() !== "") {
      return String(v).trim();
    }
  }
  return "";
}

/**
 * True if some advance-search row has the same payer name as the OCR string (normalized exact match).
 */
export function hasExactInsuranceNameInAdvanceSearchItems(
  ocrInsuranceName: string,
  items: PayerAdvanceSearchItem[]
): boolean {
  const target = normalizePayerNameForExactMatch(ocrInsuranceName);
  if (!target) {
    return false;
  }
  for (const it of items) {
    const name = normalizePayerNameForExactMatch(it.payerName ?? "");
    if (name && name === target) {
      return true;
    }
  }
  return false;
}
